"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var specialCoverages_1 = require("../constants/specialCoverages");
var coverageTypes_1 = require("../constants/coverageTypes");
var possibleLimits = [
    { minimum: 5000, maximum: 10000 },
    { minimum: 50000, maximum: 100000 },
    { minimum: 100000, maximum: 300000 },
];
var regularType = { id: 0, code: coverageTypes_1.COVERAGE_TYPE, name: '' };
var endorsementType = { id: 0, code: coverageTypes_1.ENDORSEMENT_TYPE, name: '' };
/**
 * Note: this list will have the following coverages registered in it:
 * - 9 total coverage catalogs
 * - 5 of them classified as 'regular'
 * - 2 of them classified as 'applies deductible'
 * - 3 of them classified as 'endorsements'
 * - 1 of them classified as 'special'
 *
 * There will also be an additional "hidden" coverage catalog that has `enableUI` set to "false"
 */
var mockCoverageCatalogList = [
    {
        id: 0,
        code: '001',
        applyDeductible: false,
        enableUI: true,
        name: 'Daños a la propiedad ajena',
        minCost: 0,
        maxCost: 0,
        limits: [
            { minimun: 0, maximun: 5000, minimum: 0, maximum: 5000 },
            { minimun: 0, maximun: 50000, minimum: 0, maximum: 50000 },
            { minimun: 0, maximun: 100000, minimum: 0, maximum: 100000 },
        ],
        type: __assign({}, regularType),
    },
    {
        id: 0,
        code: '002',
        applyDeductible: false,
        enableUI: true,
        name: 'Lesiones Corporales',
        minCost: 0,
        maxCost: 0,
        limits: __spreadArrays(possibleLimits),
        type: __assign({}, regularType),
    },
    {
        id: 0,
        code: '003',
        applyDeductible: false,
        enableUI: true,
        name: 'Asistencia Médica',
        minCost: 0,
        maxCost: 0,
        limits: __spreadArrays(possibleLimits),
        type: __assign({}, regularType),
    },
    {
        id: 0,
        code: '004',
        applyDeductible: true,
        enableUI: true,
        name: 'Comprensivo',
        minCost: 0,
        maxCost: 0,
        limits: [],
        type: __assign({}, regularType),
    },
    {
        id: 0,
        code: '005',
        applyDeductible: true,
        enableUI: true,
        name: 'Colisión o vuelco',
        minCost: 0,
        maxCost: 0,
        limits: [],
        type: __assign({}, regularType),
    },
    {
        id: 0,
        code: '006',
        applyDeductible: false,
        enableUI: true,
        name: 'Endoso Platinum Plus',
        minCost: 0,
        maxCost: 0,
        limits: [],
        type: __assign({}, endorsementType),
    },
    {
        id: 0,
        code: '007',
        applyDeductible: false,
        enableUI: true,
        name: 'Endoso Platinum',
        minCost: 0,
        maxCost: 0,
        limits: [],
        type: __assign({}, endorsementType),
    },
    {
        id: 0,
        code: '008',
        applyDeductible: false,
        enableUI: true,
        name: 'Endoso Dorado Plus',
        minCost: 0,
        maxCost: 0,
        limits: [],
        type: __assign({}, endorsementType),
    },
    /**
     * This is the "special" coverage, which will be treated as a separate entity
     */
    {
        id: 0,
        code: specialCoverages_1.ASSAMOVIL_PREMIUM,
        applyDeductible: false,
        enableUI: true,
        name: 'ASSAMOVIL PREMIUM',
        minCost: 0,
        maxCost: 0,
        limits: [],
        type: __assign({}, regularType),
    },
    {
        id: 0,
        code: specialCoverages_1.LUXURY_TRANSPORTATION_SERVICE,
        applyDeductible: false,
        enableUI: true,
        name: 'USO DEL AUTO PARA SERVICIO DE TRANSPORTE DE LUJO',
        minCost: 0,
        maxCost: 0,
        limits: [],
        type: __assign({}, regularType),
    },
    /**
     * This is the "hidden" coverage, which should be ignored in all transactions
     */
    {
        id: 0,
        code: 'mock-code',
        applyDeductible: false,
        enableUI: false,
        name: 'Mock Hidden Coverage',
        minCost: 0,
        maxCost: 0,
        limits: [],
        type: __assign({}, regularType),
    },
];
exports.default = mockCoverageCatalogList;
//# sourceMappingURL=mockCoverageCatalogList.js.map